var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSnowmobile = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3a1.8 1.8 0 1 1 0 3.6A1.8 1.8 0 0 1 10 3zm3.739 2.827a.9.9 0 0 1 1.233.308l1.755 2.929 5.209 2.602c.405.203.664.619.664 1.073v2.216c0 .401-.2.776-.533.997L19.45 17.7l2.025 2.7h.753l1.238-1.238a.9.9 0 0 1 1.271 1.271l-1.5 1.5a.9.9 0 0 1-.637.263h-5.1a.898.898 0 0 1-.9-.9c0-.499.4-.9.9-.9h1.725l-1.8-2.4h-4.676a3 3 0 0 1-2.749 4.2H4a3 3 0 0 1-1.8-5.4l.3-.6 1.17-2.336c.202-.405.619-.66 1.072-.66H11.8l.9-1.2h-1.2a.9.9 0 0 1-.72-.36L9.527 9.97a.932.932 0 0 0-.742-.371.924.924 0 0 0-.848.551l-.716 1.616a.901.901 0 0 1-1.646-.73L6.29 9.42a2.725 2.725 0 0 1 4.673-.529l.986 1.309h2.1l.701-.934-1.324-2.205a.9.9 0 0 1 .308-1.234h.004zM3.999 18c-.663 0-1.199.536-1.199 1.2 0 .663.536 1.2 1.2 1.2h6c.664 0 1.2-.537 1.2-1.2 0-.664-.536-1.2-1.2-1.2H4zm6-1.8h8.457l2.344-1.564v-1.522l-4.86-2.434-2.7 3.6-.54.72H5.114l-.6 1.2H10z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSnowmobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-snowmobile.dfce078a.svg";
export { ForwardRef as ReactComponent };